// Rewrites absolute Laravel URLs (any host) pointing at /storage or /api into
// relative paths, so the browser always calls through the frontend's own
// origin (which nginx/.htaccess/setupProxy.js already proxy to Laravel)
// instead of hitting the Laravel host directly.
const toRelativeResourceUrl = (value) => {
  if (typeof value !== "string" || !/^https?:\/\//i.test(value)) {
    return value;
  }

  try {
    const parsed = new URL(value);
    if (parsed.pathname.startsWith("/storage") || parsed.pathname.startsWith("/api")) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch (e) {
    // not a parseable URL, leave untouched
  }

  return value;
};

const sanitizeResourceUrls = (data) => {
  if (Array.isArray(data)) {
    return data.map(sanitizeResourceUrls);
  }

  if (data && typeof data === "object") {
    const result = {};
    for (const key of Object.keys(data)) {
      result[key] = sanitizeResourceUrls(data[key]);
    }
    return result;
  }

  if (typeof data === "string") {
    return toRelativeResourceUrl(data);
  }

  return data;
};

export default { toRelativeResourceUrl, sanitizeResourceUrls };
